import { useMemo } from "react";
import { useFetchEcompage } from "@/apis/queryFunctions/ecompagesFunctions";
import appendImageUrlFromAPI from "@/utils/appendImageUrlFromAPI";

export const NEWS_PAGE_SLUG = "trang-tin-tuc-website-viet-thien";

export function useNewsPageData(locale = "vi") {
  const { data: pageData, isLoading } = useFetchEcompage(NEWS_PAGE_SLUG, locale);

  const getBannerUrl = (bannerKey: string, fallbackImg: string) => {
    const actualData = (pageData as any)?.root || pageData;
    const addOnList: any[] = Array.isArray(actualData?.add_on_data_2)
      ? actualData.add_on_data_2
      : [];

    const found = addOnList.find(
      (item) => (item?.title || "").toLowerCase() === bannerKey.toLowerCase()
    );

    if (found?.picture && found?.shared !== false) {
      return appendImageUrlFromAPI({ src: found.picture, size: "2k" });
    }

    return fallbackImg;
  };

  return { pageData, isLoading, getBannerUrl };
}

export function useNewsBanner(
  bannerKey: string,
  fallbackImg: string,
  locale = "vi"
) {
  const { pageData, getBannerUrl } = useNewsPageData(locale);

  return useMemo(() => {
    return getBannerUrl(bannerKey, fallbackImg);
  }, [pageData, bannerKey, fallbackImg]);
}
